// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
    padding: 20px;
    min-height: 100vh;
    width: 100%;
}

.dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.dashboard-header h1 {
    margin: 0;
    font-size: 32px;
    font-weight: 600;
}

.dashboard-controls {
    display: flex;
    gap: 12px;
    align-items: center;
}

/* Tablette */
@media (max-width: 1023px) {
    .dashboard-container {
        padding: 16px;
    }

    .dashboard-container h1 {
        font-size: 28px;
        margin-bottom: 20px;
    }
}

/* Mobile */
@media (max-width: 767px) {
    .dashboard-container {
        padding: 12px;
    }

    .dashboard-container h1 {
        font-size: 24px;
        margin-bottom: 16px;
    }
}

.layout {
    position: relative;
}

.widget {
    display: flex;
    flex-direction: column;
}


/* Styles pour react-grid-layout */
.react-grid-layout {
    position: relative;
    transition: height 200ms ease;
    height: calc(100vh - 150px) !important;
    max-height: calc(100vh - 150px) !important;
    width: 100%;
    overflow-y: auto;
}

.react-grid-item {
    transition: all 200ms ease;
    transition-property: left, top, width, height;
    box-sizing: border-box;
}

.react-grid-item.cssTransforms {
    transition-property: transform, width, height;
}

.react-grid-item.resizing {
    transition: none;
    z-index: 100;
}

.react-grid-item.react-draggable-dragging {
    transition: none;
    z-index: 100;
}

.react-grid-item.dropping {
    visibility: hidden;
}

.react-grid-item.react-grid-placeholder {
    background: rgba(102, 126, 234, 0.2);
    opacity: 0.5;
    transition-duration: 100ms;
    z-index: 2;
    -webkit-user-select: none;
    -o-user-select: none;
    user-select: none;
    border-radius: 8px;
}

/* Styles pour les poignées de redimensionnement */
.react-resizable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
}

.react-resizable-handle-se {
    bottom: 0;
    right: 0;
    cursor: se-resize;
}

.react-resizable-handle-se::after {
    content: "";
    position: absolute;
    right: 3px;
    bottom: 3px;
    width: 5px;
    height: 5px;
    border-right: 2px solid rgba(0, 0, 0, 0.4);
    border-bottom: 2px solid rgba(0, 0, 0, 0.4);
}

.react-resizable-handle-sw {
    bottom: 0;
    left: 0;
    cursor: sw-resize;
}

.react-resizable-handle-nw {
    top: 0;
    left: 0;
    cursor: nw-resize;
}

.react-resizable-handle-ne {
    top: 0;
    right: 0;
    cursor: ne-resize;
}

.react-resizable-handle-w,
.react-resizable-handle-e {
    top: 50%;
    margin-top: -10px;
    cursor: ew-resize;
}

.react-resizable-handle-w {
    left: 0;
}

.react-resizable-handle-e {
    right: 0;
}

.react-resizable-handle-n,
.react-resizable-handle-s {
    left: 50%;
    margin-left: -10px;
    cursor: ns-resize;
}

.react-resizable-handle-n {
    top: 0;
}

.react-resizable-handle-s {
    bottom: 0;
}

/* Widget responsive */

/* Tablette - ajuster la hauteur du grid */
@media (max-width: 1023px) {
    .react-grid-layout {
        height: calc(100vh - 130px) !important;
        max-height: calc(100vh - 130px) !important;
    }
}

/* Mobile - ajuster la hauteur du grid */
@media (max-width: 767px) {
    .widget {
        margin-bottom: 8px;
    }

    .react-grid-item {
        touch-action: none;
    }

    .react-grid-layout {
        height: calc(100vh - 110px) !important;
        max-height: calc(100vh - 110px) !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Componant/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA,aAAa;AACb;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA,WAAW;AACX;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;;AAGA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,sCAAsC;IACtC,0CAA0C;IAC1C,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,6CAA6C;IAC7C,sBAAsB;AAC1B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,0BAA0B;IAC1B,UAAU;IACV,yBAAyB;IAGzB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,kDAAkD;AAClD;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,WAAW;IACX,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,SAAS;IACT,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,MAAM;IACN,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,iBAAiB;AACrB;;AAEA;;IAEI,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;;IAEI,SAAS;IACT,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;AACb;;AAEA,sBAAsB;;AAEtB,0CAA0C;AAC1C;IACI;QACI,sCAAsC;QACtC,0CAA0C;IAC9C;AACJ;;AAEA,wCAAwC;AACxC;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sCAAsC;QACtC,0CAA0C;IAC9C;AACJ","sourcesContent":[".dashboard-container {\n    padding: 20px;\n    min-height: 100vh;\n    width: 100%;\n}\n\n.dashboard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.dashboard-header h1 {\n    margin: 0;\n    font-size: 32px;\n    font-weight: 600;\n}\n\n.dashboard-controls {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n/* Tablette */\n@media (max-width: 1023px) {\n    .dashboard-container {\n        padding: 16px;\n    }\n\n    .dashboard-container h1 {\n        font-size: 28px;\n        margin-bottom: 20px;\n    }\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n    .dashboard-container {\n        padding: 12px;\n    }\n\n    .dashboard-container h1 {\n        font-size: 24px;\n        margin-bottom: 16px;\n    }\n}\n\n.layout {\n    position: relative;\n}\n\n.widget {\n    display: flex;\n    flex-direction: column;\n}\n\n\n/* Styles pour react-grid-layout */\n.react-grid-layout {\n    position: relative;\n    transition: height 200ms ease;\n    height: calc(100vh - 150px) !important;\n    max-height: calc(100vh - 150px) !important;\n    width: 100%;\n    overflow-y: auto;\n}\n\n.react-grid-item {\n    transition: all 200ms ease;\n    transition-property: left, top, width, height;\n    box-sizing: border-box;\n}\n\n.react-grid-item.cssTransforms {\n    transition-property: transform, width, height;\n}\n\n.react-grid-item.resizing {\n    transition: none;\n    z-index: 100;\n}\n\n.react-grid-item.react-draggable-dragging {\n    transition: none;\n    z-index: 100;\n}\n\n.react-grid-item.dropping {\n    visibility: hidden;\n}\n\n.react-grid-item.react-grid-placeholder {\n    background: rgba(102, 126, 234, 0.2);\n    opacity: 0.5;\n    transition-duration: 100ms;\n    z-index: 2;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n    border-radius: 8px;\n}\n\n/* Styles pour les poignées de redimensionnement */\n.react-resizable-handle {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n}\n\n.react-resizable-handle-se {\n    bottom: 0;\n    right: 0;\n    cursor: se-resize;\n}\n\n.react-resizable-handle-se::after {\n    content: \"\";\n    position: absolute;\n    right: 3px;\n    bottom: 3px;\n    width: 5px;\n    height: 5px;\n    border-right: 2px solid rgba(0, 0, 0, 0.4);\n    border-bottom: 2px solid rgba(0, 0, 0, 0.4);\n}\n\n.react-resizable-handle-sw {\n    bottom: 0;\n    left: 0;\n    cursor: sw-resize;\n}\n\n.react-resizable-handle-nw {\n    top: 0;\n    left: 0;\n    cursor: nw-resize;\n}\n\n.react-resizable-handle-ne {\n    top: 0;\n    right: 0;\n    cursor: ne-resize;\n}\n\n.react-resizable-handle-w,\n.react-resizable-handle-e {\n    top: 50%;\n    margin-top: -10px;\n    cursor: ew-resize;\n}\n\n.react-resizable-handle-w {\n    left: 0;\n}\n\n.react-resizable-handle-e {\n    right: 0;\n}\n\n.react-resizable-handle-n,\n.react-resizable-handle-s {\n    left: 50%;\n    margin-left: -10px;\n    cursor: ns-resize;\n}\n\n.react-resizable-handle-n {\n    top: 0;\n}\n\n.react-resizable-handle-s {\n    bottom: 0;\n}\n\n/* Widget responsive */\n\n/* Tablette - ajuster la hauteur du grid */\n@media (max-width: 1023px) {\n    .react-grid-layout {\n        height: calc(100vh - 130px) !important;\n        max-height: calc(100vh - 130px) !important;\n    }\n}\n\n/* Mobile - ajuster la hauteur du grid */\n@media (max-width: 767px) {\n    .widget {\n        margin-bottom: 8px;\n    }\n\n    .react-grid-item {\n        touch-action: none;\n    }\n\n    .react-grid-layout {\n        height: calc(100vh - 110px) !important;\n        max-height: calc(100vh - 110px) !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
